import React from 'react';
import { FilterBadgeHookParams, AdAccountBadgeHookResult } from '../types';

interface AdAccount {
  id: string;
  name: string;
}

interface UseAdAccountBadges extends FilterBadgeHookParams {
  adAccounts: AdAccount[];
  adAccountIds?: string[];
}

export const useAdAccountBadges = ({ adAccounts, adAccountIds = [] }: UseAdAccountBadges): AdAccountBadgeHookResult => {
  const adAccountBadges = React.useMemo(
    () => adAccounts?.filter((account) => adAccountIds.includes(account.id)),
    [adAccounts, adAccountIds],
  );

  return {
    adAccountBadgesProps: {
      data: adAccountBadges,
    },
  };
};
